<div class="header">
    <h2>{{ 'milkrun.transportation-requests.atom-requests.title' | translate }}</h2>
</div>
<app-transport-requests-table
    class="content"
    [transports]="toolRequests"
    [tableConfig]="tableConfig"
    [isLoading]="isLoading"
    [isMaterial]="false"
    (loadTransportAtAtom)="onLoadToolRequest($event)"
    (unloadTransportAtAtom)="onUnloadToolRequest($event)"
    (pageChange)="onPageChange($event)">
</app-transport-requests-table>
<app-confirmation-modal
    (confirmEvent)="onConfirmAction($event)"
    [confirmOnlyMode]="true"
    [isConfirmationInProgress]="isLoading"
    [confirmButtonDisabled]="hasConfirmationInProgress"
    [title]="'milkrun.transportation-requests.atom-requests.confirmation.popupTitle' | translate"
    [question]="'milkrun.transportation-requests.atom-requests.confirmation.popupQuestion' | translate"
    [message]="'milkrun.transportation-requests.atom-requests.confirmation.popupMessage' | translate">
</app-confirmation-modal>
